import { PlusCircleOutlined } from '@ant-design/icons';
import { TextLinkButton, styleVariables } from '@lib/common';
import { Popover, Space } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledTextLinkButton = styled(TextLinkButton).withConfig({
  displayName: "add-more-question-popovercomponent__StyledTextLinkButton",
  componentId: "sc-16yll81-0"
})(["color:", ";font-weight:500;line-height:24px;"], styleVariables.colors.colorPrimaryBase);
export var AddMoreQuestionPopover = function AddMoreQuestionPopover(_ref) {
  var onCreateQuestion = _ref.onCreateQuestion,
      question = _ref.question,
      children = _ref.children,
      labelTranslation = _ref.labelTranslation;

  var moreContent = function moreContent() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick() {
            return onCreateQuestion({
              currentQuestionId: question.id.toString(),
              aboveQuestionId: question.previousQuestionId
            });
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: labelTranslation.addQuestionAbove
        }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick() {
            return onCreateQuestion({
              currentQuestionId: question.id.toString(),
              belowQuestionId: question.id.toString()
            });
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: labelTranslation.addQuestionBelow
        })]
      })
    });
  };

  return /*#__PURE__*/_jsx(Popover, {
    placement: "right",
    content: moreContent(),
    trigger: 'click',
    children: children
  });
};